import { RootState } from "../hooks";

export const getAdminSelector = (state: RootState) => state.admin;